<template>
	<div v-cloak>
		<div class="align-items-center large-gap">
			<ap-button text="Ajouter" @click="dateClick"></ap-button>
			<ap-button text="Exporter" @click="showExportModal = true" variant="outline" data-cy="export_agenda"></ap-button>
		</div>

		<div v-if="showExportModal" class="modal">
			<div class="modal-content">
				<p>Exporter les rendez-vous entre deux dates :</p>
				<div id="export-agenda-date-selection">
					<p><label for="exportStartDate">Du</label> <input name="exportStartDate" type="date" v-model="exportStartDate"></p>
					<p><label for="exportEndDate">Au</label> <input name="exportEndDate" type="date" v-model="exportEndDate"></p>
				</div>
				<div class="modal-buttons">
					<ap-button text="Annuler" @click="showExportModal = false" variant="outline" />
					<ap-button text="Exporter" @click="downloadAgenda" variant="primary" :loading="exportLoading" :disabled="!exportStartDate || !exportEndDate" />
				</div>
			</div>
		</div>

		<div class="align-items-center large-gap">
			<div id="filter-therapist-container" v-if="isOfferUltime && therapists.length > 1" > 
				<label for="therapise-select">Practicien </label>
				<select
					class="zoo-input select-patient-club-animal"
					name="therapist"
					id="therapist-select"
					v-model="selectedTherapist"
					tabindex="1"
					@change="filterSessions"
				>
					<option value='Tous'>Tous</option>
					<option
						v-for="therapist in therapists"
						:value="therapist"
						:key="therapist"
					>
					{{ therapist.lastname }} {{ therapist.firstname !== null ? therapist.firstname : therapist.email }}
					</option>
				</select>
			</div>

			<div id="session-type-container" v-if="sessionTypes.length > 1">
				<label for="session-type-select">Type de séance </label>
				<select
					name="session-type-select"
					v-model="sessionType"
					tabindex="2"
					@change="filterSessions"
					class="select-patient-club-animal"
					>
						<option value='Tous'>Tous</option>
						<option
							v-for="sessionType in sessionTypes"
							:key="sessionType"
							:value="sessionType"
						>
						{{ sessionType.name }}
						</option>
				</select>
			</div>

			<div>
				<div id="toggle-div" v-if="showAnimalDistribution()">
					<input type="checkbox" id="toggle_input" tabindex="6" v-model="animalDistribution" @change="showAnimalsColor">
					<label for="toggle_input" class="toggle_label">Répartition animaux</label>
					<label id ="repartition_animaux_label">Répartition animaux</label>
				</div>
			</div>

		</div>
		<div v-if="animalDistribution && animalColors.length > 0" class="animal-colors" style="height: 4rem;">
			<div v-for="color in animalColors" :key="color.animalId" class="animal-color-item">
				<span :style="{ backgroundColor: color.color }"></span>
				<span :style="{ display: 'inline-block', width: '16px', height: '16px', backgroundColor: color.color, borderRadius: '50%', marginRight: '8px', border: '1px solid #ccc' }"></span>
				{{ color.label }}
			</div>
		</div>
		<div v-else style="margin-top: 4rem">
		</div>
		<div id="full-calendar">
			<FullCalendar ref="fullCalendar" :options="calendarOptions" />
		</div>
	</div>
</template>


<script>
import _ from 'lodash';
import FullCalendar from '@fullcalendar/vue3';
import ApButton from '../../commons/APButton';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import frLocale from '@fullcalendar/core/locales/fr';
import { COLORS_TYPES } from '../../../services/colorsType';
import { getColors } from '../../../services/personalization';
import { mapState } from 'vuex';
import { getSessions } from '../../../services/session'
import { getFirstAndLastDaysOfWeek } from '../../../services/apdate'
import { exportAgenda } from '../../../services/downloads'
import { getTherapists } from '../services/team'
import { getTherapistSessionTypes } from '../../../services/therapists'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'

export default ({
	// eslint-disable-next-line
    name: 'Sessions',
	components: {
		FullCalendar,
		ApButton
	},
	metaInfo: {
		title: 'Sessions',
		meta: [
			{ vmid: 'description', name:'description', content: 'liste des séances de zoothérapie'}
		]	
	},
    data() {
		return {
			isOfferUltime: false,
			therapists: [],
			selectedTherapist: 'Tous',
			errors: [],
			tippyInstances: [], // Pour stocker les instances Tippy
			calendarOptions: {
				plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
				headerToolbar: {
					left: 'prev,next today',
					center: 'title',
					right: this.$store.state.isMobile ? '':'timeGridDay,timeGridWeek,dayGridMonth'
				},
				initialDate: this.$route.params ? this.getInitialDate() : new Date().toUTCString(),
				initialView: this.$store.state.isMobile ? 'timeGridDay':'timeGridWeek',
				dateClick: this.dateClick,
				eventClick: this.sessionClick,
				eventContent: this.customEventContent,
				events: [],
				customButtons: {
					prev: {click: () => {
						let calendarApi = this.$refs.fullCalendar.getApi()
						calendarApi.prev()
						let date = new Date(this.$refs.fullCalendar.calendar.getCurrentData().currentDate)
						let dates = getFirstAndLastDaysOfWeek(date)
						this.$store.state.selectedCalendarDates=dates
						this.getSessionsByDate(dates.startDate, dates.endDate)
					}},
					next: {click: () => {
						let calendarApi = this.$refs.fullCalendar.getApi()
						calendarApi.next()
						let date = new Date(this.$refs.fullCalendar.calendar.getCurrentData().currentDate)
						let dates = getFirstAndLastDaysOfWeek(date)
						this.$store.state.selectedCalendarDates=dates
						this.getSessionsByDate(dates.startDate, dates.endDate)
					}},
				},
				locale: frLocale,
				scrollTime: '08:00:00',
				allDaySlot: false,
				height: '45rem',
				editable: true,
				eventDidMount: (info) => {
					this.createTooltip(info)
				}
			},
			currentState: false,
			colorPersonalization: {
				colors: null,
				type: "DEFAULT"
			},
			sessions: [],
			sessionType: 'Tous',
			sessionTypes: [],
			animalDistribution: false,
			animals: [],
			animalColors: [],
			showExportModal: false,
			exportLoading: false,
			exportStartDate: '',
			exportEndDate: '',
		};
	},
	computed: {
		...mapState(['patients', 'animals', 'clubs'])
	},
	mounted() {
		this.$store.dispatch('initAnimals')
		if (screen.width < 800) {
			this.calendarOptions.initialView = 'dayGridDay'
		}
		getColors().then((colorPersonalization) => {
			this.colorPersonalization = colorPersonalization
		})
		this.offerName = this.$store.getters.user.tenant.offer
		this.isOfferUltime = this.offerName === 'ULTIME'
		if (this.isOfferUltime)
			this.callGetTherapists()

		let dates = getFirstAndLastDaysOfWeek(this.getInitialDate())
		this.getSessionsByDate(dates.startDate, dates.endDate)
		this.getSessionTypeByTherapist()
		this.exportStartDate = dates.startDate
		this.exportEndDate = dates.endDate
	},
	methods: {
		createTooltip(info) {
			const event = info.event
			const element = info.el
			
			// Contenu du tooltip
			const tooltipContent = this.generateTooltipContent(event)
			
			// Création de l'instance Tippy
			const tippyInstance = tippy(element, {
				content: tooltipContent,
				allowHTML: true,
				theme: 'custom',
				placement: 'top',
				arrow: true,
				animation: 'fade',
				duration: [200, 150],
				delay: [300, 0], // Délai d'apparition et de disparition
				interactive: false,
				hideOnClick: false,
				trigger: 'mouseenter focus',
				maxWidth: 350,
				offset: [0, 10],
				
				// Configuration avancée
				appendTo: () => document.body, // Évite les problèmes de z-index
				
				// Callbacks
				onShow: (instance) => {
				// Animation personnalisée à l'apparition
				instance.popper.style.transform = 'translateY(-5px)'
				},
				
				onHidden: (instance) => {
				// Nettoyage après disparition
				instance.popper.style.transform = ''
				}
			})
			
			// Stocker l'instance pour pouvoir la détruire plus tard
			this.tippyInstances.push(tippyInstance)
		},
		destroyTooltips() {
			this.tippyInstances.forEach(instance => {
				if (instance) {
				instance.destroy()
				}
			})
			this.tippyInstances = []
		},
		generateTooltipContent(event) {
			const startDate = this.formatDate(event.start)
			const endDate = event.end ? this.formatDate(event.end) : null
			const props = event.extendedProps
			const animalNames = props.animalIds.map(animalId => {
			
				var foudanimal = this.$store.state.animals.find(sa => sa.id === animalId);
				if (foudanimal) {
					return foudanimal.name
				}
			})

			return `
				<div class="tooltip-content">
				<div class="tooltip-header">
					<h4>${event.title}</h4>
					<div class="event-color" style="background-color: ${event.backgroundColor}"></div>
				</div>
				
				<div class="tooltip-body">
					<div class="tooltip-row">
					<span class="tooltip-label">📅 Début:</span>
					<span>${startDate}</span>
					</div>
					
					${endDate ? `
					<div class="tooltip-row">
						<span class="tooltip-label">⏰ Fin:</span>
						<span>${endDate}</span>
					</div>
					` : ''}
					
					${props.description ? `
					<div class="tooltip-row">
						<span class="tooltip-label">📋 Description:</span>
						<span>${props.description}</span>
					</div>
					` : ''}

					${props.therapistName ? `
					<div class="tooltip-row">
						<span class="tooltip-label">👥 Praticien:</span>
						<span>${props.therapistName}</span>
					</div>
					` : ''}
					
					${props.patientName ? `
					<div class="tooltip-row">
						<span class="tooltip-label">👥 Patient:</span>
						<span>${props.patientName}</span>
					</div>
					` : ''}

					${props.location ? `
					<div class="tooltip-row">
						<span class="tooltip-label">📍 Lieu:</span>
						<span>${props.location}</span>
					</div>
					` : ''}
					
					${props.paid ? `
					<div class="tooltip-row">
						<span class="tooltip-label"><svg xmlns="http://www.w3.org/2000/svg" style="vertical-align: middle;" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
								<rect x="2" y="5" width="20" height="14" rx="2" ry="2" stroke="#4caf50" fill="#e8f5e9"/>
								<line x1="2" y1="10" x2="22" y2="10" stroke="#4caf50"/>
								<circle cx="8" cy="16" r="1" fill="#4caf50"/>
								<circle cx="16" cy="16" r="1" fill="#4caf50"/>
							</svg> Payé:</span>
						<span>${props.paid ? 'oui' : 'non'}</span>
					</div>
					` : ''}

					${props.animalIds && props.animalIds.length > 0 ? `
					<div class="tooltip-row">
						<span class="tooltip-label">🐾 Animaux:</span>
						<span>${animalNames.join(', ')}</span>
					</div>
					` : ''}
				</div>
				</div>	`
		},
		formatDate(date) {
			return new Date(date).toLocaleDateString('fr-FR', {
				weekday: 'short',
				month: 'short',
				day: 'numeric',
				hour: '2-digit',
				minute: '2-digit'
			})
		},
		showAnimalDistribution() {
			const allAnimalIds = this.sessions.flatMap(session => (session.animalIds || []).filter(id => id !== null));
			// Obtenir les valeurs uniques
			if (allAnimalIds.length === 0) return false;
			const uniqueAnimalIds = [...new Set(allAnimalIds)];
			return uniqueAnimalIds.length > 0;	
		},
		showAnimalsColor() {
			if (!this.animalDistribution || this.$store.state.animals === null || this.$store.state.animals.length === 0) {
				this.animalColors = [];
				this.updateEvents(this.sessions);
				return;
			}

			// Récupérer tous les animalIds de toutes les sessions et les aplatir dans un seul tableau
			const allAnimalIds = this.sessions.flatMap(session => session.animalIds || []);
			// Obtenir les valeurs uniques
			const uniqueAnimalIds = [...new Set(allAnimalIds)];
			//attribuer une couleur a chaquel animal

			let colorsByAnimals = uniqueAnimalIds.map(animalId => {
				var r = Math.floor(Math.random() * 255);
				var g = Math.floor(Math.random() * 255);
				var b = Math.floor(Math.random() * 255);
				var foudanimal = this.$store.state.animals.find(sa => sa.id === animalId);
				if (foudanimal) {
					return {
						label: foudanimal.name,
						color: "rgba(" + r + "," + g + "," + b + ", 1)",
						animalId: animalId
					}
				}
			}).filter(item => item !== undefined);

			this.animalColors = colorsByAnimals;
			this.updateEvents(this.sessions);
		},	
		customEventContent(info) {
			let isSessionPaid = this.sessions.filter( s => s.id === info.event.id)[0].paid
			let animalColors = this.animalDistribution ? this.animalColors.filter(ac => (info.event.extendedProps.animalIds || []).includes(ac.animalId)) : [];

			const div = document.createElement('div');
			div.className = 'event-content';
			div.style.position = 'relative';
			div.style.fontSize = '1em';

			div.innerHTML = `
				<div>
				<div>${info.event.title}</div>
				${isSessionPaid ? `<div style="cursor: pointer" title="payée"><span style="position:absolute;top:-4px;right:5px;font-size:20px;">\u20AC</span></div>` : ''}
				</div>
				<div>${info.timeText}</div>
				<div class="animal-colors" style="position: absolute; bottom: 0; transform: translate(-10%, 10%);">
				${animalColors.map(ac => `<span style="display:inline-block;width:16px;height:16px;background-color:${ac.color};border-radius:50%;margin-right:4px;"></span>`).join('')}
				</div>
			`;

			return { domNodes: [div] };
		},
		getSessionsByDate(startDate, endDate) {
			getSessions(startDate, endDate).then((sessions) => {
				this.sessions = sessions
				this.updateEvents(this.sessions)
			}).catch((response) => {
				if (response.data && response.data.errorCode !== 'E123') {
					this.$router.push('/');
					this.$store.dispatch('logout')
				}
			})
		},
		getSessionTypeByTherapist(){
			getTherapistSessionTypes(this.$store.state.user.id).then(response => {
				this.sessionTypes = response
			});
		},
		callGetTherapists() {
			getTherapists().then(team => {
				this.therapists = team.members
			})
		},
		getInitialDate() {
			let initialDate = new Date();
			if (this.$router.options.history.state && this.$router.options.history.state.initialDate !== undefined) {
				initialDate = new Date(this.$router.options.history.state.initialDate );
			} else if (this.$store.state.selectedCalendarDates.length !== 0 && this.$store.state.selectedCalendarDates !== undefined) {
				initialDate = new Date(this.$store.state.selectedCalendarDates.startDate );
			}

			return initialDate
		},
		getFormattedDate(dateToFormat) {
			return `${dateToFormat.toISOString().split('T')[0]}T${dateToFormat.toLocaleTimeString('fr-FR')}`
		},
		filterSessions(){
			let therapistFilter = this.selectedTherapist === 'Tous' ? null : this.selectedTherapist.id;
			let sessionTypeFilter = this.sessionType === 'Tous' ? null : this.sessionType.id;

			this.updateEvents(this.sessions.filter(elt => (therapistFilter === null || elt.therapistId === therapistFilter) && (sessionTypeFilter === null || elt.sessionTypeId === sessionTypeFilter)))
		},
		updateEvents(sessions) {
			let defineColor = this.defineColor;
			this.calendarOptions.events = sessions.map(function(elt){	
				return {
					title : elt.title, 
					start: new Date(elt.date + " " + elt.startTime), 
					end: new Date(elt.date + " " + elt.endTime),
					id: elt.id, 
					extendedProps: {
						animalIds: elt.animalIds,
						paid: elt.paid,
						therapistName : elt.therapistName,
						patientName: elt.patientName
					},
					color: defineColor(elt)
				};
			});
		},
		defineColor(elt) {
			let color;
			if (elt.validated === false)
				return "#FF0000"
			if (this.colorPersonalization.type === COLORS_TYPES.CLUBS.value) {
				color =  _.find(this.colorPersonalization.colors, el => el.objectId === elt.clubId)
			} else if (this.colorPersonalization.type === COLORS_TYPES.THERAPISTS.value){
				color = _.find(this.colorPersonalization.colors, el => el.objectId === elt.therapistId)
			}
			
			if (color)
				return color.hexa
			
			return this.colorPersonalization.type !== COLORS_TYPES.DEFAULT.value ? 'darkblue' : elt.paid ? (elt.patientPresent ? 'green':'orange') :'darkblue'
		},
		dateClick(event) {
			let initialDate = event.dateStr
			if (typeof PointerEvent !== 'undefined' && event instanceof PointerEvent)
				initialDate = new Date()

			this.$router.push({name: 'CreateSession', state: { initialDate }})
		},
		sessionClick(event) {
			this.$router.push({ name: 'EditSession', params: { id : event.event._def.publicId } })
		},
		downloadAgenda() {
			this.exportLoading = true
			exportAgenda(this.exportStartDate, this.exportEndDate)
				.then((response) => {
					let docUrl = document.createElement('a');
					docUrl.href = window.URL.createObjectURL(new Blob([response], { type: 'text/csv' }));
					docUrl.download = `agenda_${this.exportStartDate}_${this.exportEndDate}.csv`;
					docUrl.click();
					this.showExportModal = false
				})
				.catch(() => {
					this.$toast.error('Erreur lors de l\'export de l\'agenda.');
				})
				.finally(() => {
					this.exportLoading = false
				})
		}
	},
	beforeUnmount() {
		// Important : nettoyer les instances Tippy
		this.destroyTooltips()
	}
})
</script>
<style scoped>

#filter-therapist-container {
	margin: 2rem 0 2rem 0;
}
#repartition_animaux_label {
	margin-left: 0.5rem;
}

</style>